import gql from 'graphql-tag'

import {
  observationContributors,
  observationInfo,
  observationLearningContentAssets,
  observationLearningOutcomes,
  observationLearningRecords,
  observationMedia,
  observationRooms,
  observationTaggedChildrenWithInfo,
} from '~/modules/observations'

export const CREATE_OBSERVATION = gql`
  mutation createObservation(
    $childFkeys: [String]
    $observationDate: Date
    $description: String
    $futurePlanning: String
    $learningOutcomeIds: [Int]
    $learningRecords: [LearningRecordInput]
    $mediaIds: [Int]
    $planningDate: Date
    $roomFkeys: [String]!
    $serviceFkey: String!
    $observationTime: String
    $timezone: String
    $title: String!
    $learningContentAssetIds: [Int]
  ) {
    createObservation(
      observation: {
        childFkeys: $childFkeys
        date: $observationDate
        description: $description
        futurePlanning: $futurePlanning
        learningOutcomeIds: $learningOutcomeIds
        mediaIds: $mediaIds
        planningDate: $planningDate
        roomFkeys: $roomFkeys
        serviceFkey: $serviceFkey
        timezone: $timezone
        time: $observationTime
        title: $title
        learningRecords: $learningRecords
        learningContentAssetIds: $learningContentAssetIds
      }
    ) {
      id
      serviceFkey
      ...ObservationContributors
      ...ObservationInfo
      ...ObservationLearningOutcomes
      ...ObservationLearningRecords
      ...ObservationMedia
      ...ObservationRooms
      ...ObservationTaggedChildrenWithInfo
      ...ObservationLearningContentAssets
    }
  }
  ${observationContributors}
  ${observationInfo}
  ${observationLearningOutcomes}
  ${observationLearningRecords}
  ${observationMedia}
  ${observationRooms}
  ${observationTaggedChildrenWithInfo}
  ${observationLearningContentAssets}
`

export const DELETE_OBSERVATION = gql`
  mutation deleteObservation($id: ID) {
    deleteObservation(id: $id) {
      id
    }
  }
`

export const PUBLISH_OBSERVATION = gql`
  mutation publishObservation($id: ID) {
    publishObservation(id: $id) {
      id
      status
    }
  }
`

export const UPDATE_OBSERVATION_BOOKMARK = gql`
  mutation updateObservationBookmark($id: Int!, $bookmarked: Boolean) {
    updateObservation(observation: { id: $id, bookmarked: $bookmarked }) {
      id
      bookmarked
    }
  }
`

export const UPDATE_OBSERVATION = gql`
  mutation updateObservation(
    $childFkeys: [String]
    $observationDate: Date
    $description: String
    $futurePlanning: String
    $id: Int!
    $learningOutcomeIds: [Int]
    $learningRecords: [LearningRecordInput]
    $mediaIds: [Int]
    $planningDate: Date
    $roomFkeys: [String]!
    $title: String
    $timezone: String
    $observationTime: String
    $learningContentAssetIds: [Int]
  ) {
    updateObservation(
      observation: {
        childFkeys: $childFkeys
        date: $observationDate
        description: $description
        futurePlanning: $futurePlanning
        id: $id
        learningOutcomeIds: $learningOutcomeIds
        learningRecords: $learningRecords
        mediaIds: $mediaIds
        planningDate: $planningDate
        roomFkeys: $roomFkeys
        title: $title
        timezone: $timezone
        time: $observationTime
        learningContentAssetIds: $learningContentAssetIds
      }
    ) {
      id
      ...ObservationContributors
      ...ObservationInfo
      ...ObservationLearningOutcomes
      ...ObservationLearningRecords
      ...ObservationMedia
      ...ObservationRooms
      ...ObservationTaggedChildrenWithInfo
      ...ObservationLearningContentAssets
    }
  }
  ${observationContributors}
  ${observationInfo}
  ${observationLearningOutcomes}
  ${observationLearningRecords}
  ${observationMedia}
  ${observationRooms}
  ${observationTaggedChildrenWithInfo}
  ${observationLearningContentAssets}
`
